import {ControllableDialog, DialogController} from "./index";
import {setCookie} from "../view-script";

export default function setup(controller: DialogController): ControllableDialog {
	const form = document.getElementById("do-we-know-you");
	if (!(form instanceof HTMLFormElement)) {
		throw new Error();
	}

	form.addEventListener('submit', async e => {
		e.preventDefault();
		e.stopPropagation();

		controller.show("whitepaper-forms-waiting");
		controller.setFormFilledOut(true);
		controller.askedForEmail = true;

		setCookie((form.elements.namedItem("email_address") as HTMLInputElement).value);

		await controller.performDownload(resp => {
			//TODO: Handle errors
		});
	});
	return {};
}
